import { RoutePoint } from '@/javascript/domain/entities/maps/route-point'
import { ListMapper } from './mapper'
import { RemoteRoutePoint } from '@/javascript/data/entities'

export class RoutePointMapper extends ListMapper<RoutePoint, RemoteRoutePoint> {
  toEntity (data: RemoteRoutePoint): RoutePoint {
    return {
      sequence: data.sequence,
      type: data.point_type === 0 ? 'vehicle-origin' : data.point_type === 2 ? 'vehicle-destination' : 'service-delivery',
      reference: data.work?.id?.toString() ?? '',
      referenceName: data.work?.title ?? '',
      arrivalTime: data.arrival_time,
      departureTime: data.departure_time,
      location: {
        address: data.location_address,
        lat: parseFloat(data.location_lat),
        lng: parseFloat(data.location_lng)
      }
    }
  }
}
